<template>
	<div v-if="show" class="dz-feedback" ref="feedback" :style="styles.bell">
		<a @click="openForm()" class="dz-feedback__text" :style="styles.text" @mouseenter="$event.target.style.textDecoration = 'underline'" @mouseleave="$event.target.style.textDecoration = 'none'">
			Signaler une erreur <br>ou demander un complément
		</a>
		<a class="dz-feedback__close" :style="styles.close" @mouseenter="$event.target.style.opacity = 1" @mouseleave="$event.target.style.opacity = 0.7" @click="show = false">
		</a>
	</div>
</template>
<script>
	import close from 'global/assets/close.svg' 
	import bell from 'global/assets/bell.svg'
	import { isDev, getDzPos, throttle, inIframe } from '../js/apps.js'
	export default {
		name: 'Feedback',
		data: function() {
			return {
				bell: bell,
				close: close,
				show: true,
				formUrl: 'https://contexte.typeform.com/to/kvhgKz',
				styles: {
					bell: {
				//		top: '100px',
						bottom: '-100px',
						left: '10%',
						position: 'fixed',
						textAlign: 'center',
						padding: '9px 100px 12px 100px',
						zIndex: '1',
						boxSizing: 'border-box',
						borderTop: '4px solid #e0ac31',
						borderLeft: '1px solid #aaa',
						borderRight: '1px solid #aaa',
						borderBottom: '1px solid #aaa',
						background: 'white url() 15px 16px / 25px no-repeat',
						transition: 'bottom 0.3s linear',
						cursor: 'pointer',
					},
					text: {
						font: '400 15px/20px "adelle-sans",sans-serif',
						textTransform: 'none',
						color: '#2d2d2d',
						boxSizing: 'border-box',
						textDecoration: 'none',				
					},
					close: {
						background: 'url() no-repeat left top / contain',
						position: 'absolute !important',
						opacity: 0.7,
						top: '20px !important',
						width: '20px',
						height: '20px',
						right: '20px',
						cursor: 'pointer',
					}
				}
			}
		},
		methods: {
			toggle: function() {
				if (this.show) {
					let y = window.parent.scrollY
					let bodyHeight = document.querySelector('body').offsetHeight
					if (y > getDzPos() && y < (getDzPos() + 500 + bodyHeight - window.parent.innerHeight)) {
						this.$refs.feedback.style.bottom = '40px'
					} else {
						this.$refs.feedback.style.bottom = '-100px'
					}
				}
			},
			debug: function (evt) {
				console.log(evt)
			},
			openForm: function() {
				window.open(this.formUrl, '', 'width=600,height=600')
			}
		},
		created() {
			Array.from(['bell','close']).map(asset => {
				if (!isDev()) {
					let path = this.store.dzRoot + this.store.dzPath + '/'
					if (!(this.store.dzPath.includes('template'))) path += 'front/'
					this[asset] = path + this[asset]
				}
				this.styles[asset]['backgroundImage'] = 'url(' + this[asset] + ')'
			})
			if (window.innerWidth < 600 || !inIframe()) {
				this.show = false
			}
		},
		mounted() {
			if (this.show) {
				let delay = 15000
				if (isDev()) delay = 300
				let $body = parent.document.querySelector('body')
				$body.appendChild(this.$refs.feedback)			
				setTimeout(() => {
					parent.document.addEventListener('scroll', throttle(() => {
						this.toggle()
					}, 150))
				}, delay)
			}
		}
	}
</script>

